import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Question from "../../images/icons/question.svg";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DialogTitle from "@material-ui/core/DialogTitle";
import * as yup from "yup";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";
import { FormControl, Grid, TextField } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import deLocale from "date-fns/locale/es";
import { defaultValues } from "./models";
import { useStateValue } from "../../context/store";
import Utils from "../../utils/utils";
import { updateContractFinish } from "../../actions/contract-actions";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

const useStyles = makeStyles((theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
}));

const DialogFinalize = ({
  handleClose,
  open,
  setOpen,
  contractId,
  setRefresh,
  refresh,
}) => {
  const classes = useStyles();
  const [{ breadCrumb }, dispatch] = useStateValue();
  const [minDate, setMinDate] = useState(null);
  const [error, setError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  var currentDate = new Date();
  currentDate.setMinutes(
    currentDate.getMinutes() + currentDate.getTimezoneOffset()
  );
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });
  const [maxInitDate, setMaxInitDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );

  const schema = yup.object().shape({
    finishDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .required(REQUIRED_MESSAGE),

    observation: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 caracteres")
      .max(300, "Ingrese máximo 300 caracteres"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "all",
    reValidateMode: "onChange",
  });

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
    setOpen(!open);
  };

  const finishContract = async (data) => {
    setMessage({ ...message, open: false });
    const saveResponse = await updateContractFinish(
      {
        observation: data.observation,
        finishDate: data.finishDate,
        contractId: contractId,
      },
      dispatch
    );

    if (
      saveResponse &&
      saveResponse.status >= 200 &&
      saveResponse.status < 399
    ) {
      setRefresh(!refresh);

      setTimeout(function () {
        setMessage({
          description: `Contrato finalizado exitosamente`,
          textButtonSubmit: "Aceptar",
          handleClick: closeMessage,
          oneButtons: true,
          type: "SUCCESS",
          open: true,
        });
      }, 200);
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: saveResponse?.data?.detail
            ? saveResponse?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  };

  const finishData = {
    observation: "observation",
    finishDate: "finishDate",
    contractId: "id",
  };

  const onChangeDate = (value) => {
    setMinDate(value);
    //setDuration(value);
  };

  const validateMaxInitDate = () => {
    var currentData = getValues();
    if (!currentData.endDate) {
      setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
    } else {
      setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
    }
  };

  return (
    <div>
      {message.open && (
        <ModalConfirmBase
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          type={message.type}
          open={message.open}
        />
      )}
      <Dialog
        PaperProps={{
          style: { borderRadius: 16, paddingLeft: 30, paddingRight: 30, paddingTop: 10,overflowY: "hidden", minHeight: "270px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "#7EBDCE" }}>
          <div style={{ textAlign: "center" }}>
            <img src={Question} alt="" style={{ width: "10%" }} />
            <p style={{margin: "0"}}>¿Esta seguro que desea terminar contrato con este colaborador?</p>
          </div>
        </DialogTitle>
        <DialogContent>

        </DialogContent>
        <form onSubmit={handleSubmit(finishContract)}>
          <Grid container spacing={2}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Grid item xs={12} md={4} lg={4} stlye={{ itemsAlign: "center" }}>
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        fullWidth
                        inputVariant="outlined"
                        variant="inline"
                        inputRef={register}
                        InputProps={{ readOnly: true }}
                        style={{ backgroundColor: "#ffffff" }}
                        format="dd/MM/yyyy"
                        //label="Fecha de inicio *"

                        inputProps={{
                          style: {
                            height: "18px",
                            borderRadius: "8px",
                            paddingBottom: "6.5px",
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{ shrink: false }}
                        onAccept={onChangeDate}
                        onChange={onChangeDate}
                        onOpen={validateMaxInitDate}
                        error={
                          !isDisabled &&
                          !!errors.hasOwnProperty("finishDate") &&
                          errors["finishDate"].message
                        }
                        FormHelperTextProps={{
                          style: {
                            backgroundColor: "#e0f1f8",
                            width: "100%",
                            marginLeft: "0px",
                            marginTop: "0px",
                            paddingTop: "4px",
                          },
                        }}
                        helperText={
                          !isDisabled &&
                          errors.hasOwnProperty("finishDate") &&
                          errors["finishDate"].message
                        }
                        // minDate={maxInitDate}
                         maxDate={maxInitDate}
                      />
                    }
                    control={control}
                    name="finishDate"
                    defaultValue={maxInitDate}
                    //placeholder="01/12/2022"
                    value={maxInitDate}
                    size="small"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </div>

            <Grid item xs={12} md={12} lg={12}>
              <FormControl
                fullWidth
                style={{ height: "140px", paddingTop: "5px" }}
              >
                <TextField
                  // style={{ height: "150px" }}
                  fullWidth
                  defaultValue=""
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  multiline
                  rows={4}
                  rowsMax={4}
                  variant="outlined"
                  className={classes.field}
                  type="text"
                  autoComplete="off"
                  label="Observaciones"
                  name="observation"
                  size="small"
                  error={
                    !!errors.hasOwnProperty("observation") &&
                    errors["observation"].message
                  }
                  helperText={
                    errors.hasOwnProperty("observation") &&
                    errors["observation"].message
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
          <DialogActions
            style={{ justifyContent: "space-around", paddingTop: "0px" }}
          >
            <Button
              onClick={handleClose}
              color="primary"
              variant="outlined"
              style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              color="primary"
              autoFocus
              style={{ backgroundColor: "#7EBDCE", color: "#ffffff" }}
            >
              Guardar
            </Button>
          </DialogActions>
        </form>
        {/* <FormHelperText style={{ color: "#f44336", padding: "10px" }}>
          {error && "Debe seleccionar al menos una cláusula"}
        </FormHelperText> */}
      </Dialog>
    </div>
  );
};
export default DialogFinalize;
